import React from "react";
import { Box, Typography, CircularProgress } from "@mui/material";
import styles from './styles.module.css';
import useCasinoBetplace from "../../../../api/useCasinoBetplace";


const AviatorMyBet = ({ roundId }) => {
    const { bets, loading, error, exposure, currentRoundId } = useCasinoBetplace();


       const aviatorBets = bets.filter(
        (b) => 
            b.marketType === 'CASINO' || 
            b.selection === 'AVIATOR' ||
            b.gameId === 2
    );
    const formatDate = (dateStr) => {
        if (!dateStr) return '—';
        try {
            const d = new Date(dateStr);
            return d.toLocaleString('en-IN', {
                day: '2-digit', month: '2-digit', year: 'numeric',
                hour: '2-digit', minute: '2-digit', second: '2-digit',
                hour12: true,
            });
        } catch {
            return dateStr;
        }
    };

    return (
        <Box className={styles.MatchScreen_container}>

      

            {/* Header */}
            <Box className={styles.HeaderBox}>
                <Box className={styles.HeaderBoxInner}>
                    <Typography className={styles.HeadText1}>Date</Typography>
                    <Typography className={styles.HeadText2}>Bet (INR)</Typography>
                </Box>
                <Typography className={styles.HeadText3}>X</Typography>
                <Typography className={styles.HeadText3}>Cash out (INR)</Typography>
            </Box>

            {/* Body */}
            <Box className={styles.BodyBox}>

                {loading && (
                    <Box sx={{ display: 'flex', justifyContent: 'center', padding: '16px' }}>
                        <CircularProgress size={24} sx={{ color: '#fff' }} />
                    </Box>
                )}

              

                {!loading && !error && aviatorBets.length === 0 && (
                    <Typography sx={{
                        color: '#aaa',
                        textAlign: 'center',
                        padding: '16px',
                        fontSize: '13px',
                        fontFamily: 'Poppins, sans-serif',
                    }}>
                        No bets placed yet.
                    </Typography>
                )}

                {aviatorBets.map((row, index) => {
     const hasMultiplier = row.multiplier != null && row.multiplier !== '';
                    const cashout = parseFloat(row.cashout ?? row.payout ?? 0);
                    const stake = parseFloat(row.stake ?? 0);

                    return (
                        <Box
                            key={row.betId ?? index}
                            className={hasMultiplier ? styles.GreenRow : styles.BlackRow}
                        >
                            <Box className={styles.RowInnerBox}>
                                <Typography className={styles.UserText}>
                                    {formatDate(row.date ?? row.createdAt)}
                                </Typography>
                                <Typography className={styles.BetText}>
                                    {stake.toFixed(2)}
                                </Typography>
                            </Box>

                            <Typography className={styles.AmountText}>
                                {hasMultiplier ? `${row.multiplier}x` : '—'}
                            </Typography>

                            <Typography className={styles.AmountText}>
                                {cashout.toFixed(2)}
                            </Typography>
                        </Box>
                    );
                })}

            </Box>
        </Box>
    );
};

export default AviatorMyBet;